var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import AppState from '../AppState';
import { FibreProviderTypes, TechnologyTypes, OptionServiceType, SlabFibreServiceType, } from '../models/enums';
import getServicesAvailable from './getServicesAvailable';
import getServiceUnavailable from './getServiceUnavailable';
import getMultipleServicesAvailable from './getMultipleServicesAvailable';
import getNodePlanData from './getNodePlanData';
import buildPlanDisplay from './buildPlanDisplay';
/**
 * Check if services are available for the given service qualification and address.
 *
 * @param {SQ} serviceQualification - The service qualification object.
 * @param {Address} address - The address object.
 */
const checkServicesAvailable = (serviceQualification, address) => {
    var _a, _b, _c, _d;
    const planId = AppState.get('planId');
    const { FibreProviderType, FibreServiceAssesmentResult, InternetBundlePlansWithOptions, MultipleFibreAddressData, IsCOATEligible, } = serviceQualification;
    if (MultipleFibreAddressData) {
        getMultipleServicesAvailable(MultipleFibreAddressData);
    }
    else if (InternetBundlePlansWithOptions) {
        const { InternetPlans, Options } = InternetBundlePlansWithOptions;
        const { FibreProvider, PreferredServices } = FibreServiceAssesmentResult === null || FibreServiceAssesmentResult === void 0 ? void 0 : FibreServiceAssesmentResult.FibreNetworkResult;
        const slabServiceTypeObject = FibreProvider[PreferredServices[0] - 1];
        const fibreServicesDetails = slabServiceTypeObject === null || slabServiceTypeObject === void 0 ? void 0 : slabServiceTypeObject.FibreServiceDetails[0];
        const slabServiceTypeId = fibreServicesDetails === null || fibreServicesDetails === void 0 ? void 0 : fibreServicesDetails.FibreServiceType;
        const slabFibreServiceType = SlabFibreServiceType[slabServiceTypeId];
        const isPortInUse = (_b = (_a = fibreServicesDetails === null || fibreServicesDetails === void 0 ? void 0 : fibreServicesDetails.FibreEquipmentDetails) === null || _a === void 0 ? void 0 : _a.PortDetails[0]) === null || _b === void 0 ? void 0 : _b.PortInUse;
        const copperPair = fibreServicesDetails === null || fibreServicesDetails === void 0 ? void 0 : fibreServicesDetails.CopperPairDetails.find((copperPair) => copperPair.NBNServiceStatus === 'Line In Use' || copperPair.NBNServiceStatus === 'In Use');
        const modemObject = Options.find(option => option.GroupName === 'HRO');
        const { OptionFee, NumberOfInstalments } = modemObject;
        const mutableOptions = JSON.parse(JSON.stringify(Options));
        const drupalJsObjects = AppState.get('drupalJsObjects');
        const { context } = drupalJsObjects;
        AppState.set('slabFibreServiceType', slabFibreServiceType);
        AppState.set('mutableOptions', mutableOptions);
        AppState.set('serviceFunnelPackage.address', address);
        AppState.set('serviceFunnelPackage.availableSelections', Options);
        AppState.set('serviceFunnelPackage.bundles', InternetPlans);
        AppState.set('serviceFunnelPackage.internetSelection.modemCost', (OptionFee * NumberOfInstalments).toString());
        AppState.set('serviceFunnelPackage.isCoat', IsCOATEligible === null ? false : IsCOATEligible);
        AppState.set('serviceFunnelPackage.provider', FibreProviderType);
        AppState.set('serviceFunnelPackage.serviceType', OptionServiceType[slabFibreServiceType]);
        AppState.set('serviceFunnelPackage.showServiceTransfer', (isPortInUse !== null && isPortInUse !== void 0 ? isPortInUse : false) === true || Boolean(copperPair));
        AppState.set('serviceFunnelPackage.serviceabilityClass', fibreServicesDetails.ServiceabilityClass);
        AppState.set('serviceFunnelPackage.hfcSelfAndRspProfessionalInstallEligible', (_c = fibreServicesDetails.HFCSelfAndRspProfessionalInstallEligible) !== null && _c !== void 0 ? _c : false);
        AppState.set('serviceFunnelPackage.newDevelopmentsChargeApplies', (_d = fibreServicesDetails.NewDevelopmentsChargeApplies) !== null && _d !== void 0 ? _d : false);
        // Some hackery to update the previously built plan tile minimum cost value.
        const selectedPlan = context.querySelector('#service-selected');
        // Re-display the selected plan with the matching technology type.
        const provider = FibreProviderTypes[Number(FibreProviderType)];
        let planType = ['Opticomm', 'RedTrain'].includes(provider) ? TechnologyTypes.FIBRE : TechnologyTypes.NBN;
        const reloadSelectedPlan = () => __awaiter(void 0, void 0, void 0, function* () {
            const selectedPlanData = yield getNodePlanData(planId, planType);
            selectedPlan.innerHTML = '';
            buildPlanDisplay(planId, selectedPlanData, [], 0, selectedPlan);
        });
        reloadSelectedPlan().then(response => {
            // Return plans specific to Opticomm and RedTrain, ie. Fibre plans.
            AppState.set('planType', planType);
            getServicesAvailable();
        });
    }
    else {
        getServiceUnavailable();
    }
};
export default checkServicesAvailable;
